var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C20.1992 4 20.3916 4.02912 20.5731 4.08333L12.7168 9.58273C12.2864 9.88401 11.7136 9.88401 11.2832 9.58273L3.42688 4.08333C3.60844 4.02912 3.80082 4 4 4H20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.00002C2 5.66596 2.0819 5.35103 2.22672 5.07422L10.423 10.8116C11.3699 11.4744 12.6301 11.4744 13.577 10.8116L21.7733 5.07422C21.9181 5.35103 22 5.66596 22 6.00002V13.5278C20.9385 12.5777 19.5367 12 18 12C14.6863 12 12 14.6863 12 18H4C2.89543 18 2 17.1046 2 16V6.00002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1266 13.4777C17.8381 13.1804 17.3633 13.1733 17.066 13.4618C16.7688 13.7503 16.7617 14.2251 17.0502 14.5223L18.727 16.25H14.5001C14.0858 16.25 13.7501 16.5858 13.7501 17C13.7501 17.4142 14.0858 17.75 14.5001 17.75H18.727L17.0502 19.4777C16.7617 19.7749 16.7688 20.2497 17.066 20.5382C17.3633 20.8267 17.8381 20.8196 18.1266 20.5224L21.0383 17.5224C21.3207 17.2314 21.3207 16.7686 21.0383 16.4777L18.1266 13.4777Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageForward);
export default __webpack_public_path__ + "static/media/message-forward.b9727821c7e6b2f50ca25f302c599a4c.svg";
export { ForwardRef as ReactComponent };